import {useEffect, useRef} from 'react';

export function useEnterViewportObserver<T extends HTMLDivElement>(
  callback: () => void,
) {
  const targetRef = useRef<T | null>(null);

  useEffect(() => {
    if (!window.IntersectionObserver) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        const targetIsWithinViewport = entries.some(
          ({isIntersecting}) => isIntersecting,
        );

        if (target && targetIsWithinViewport) {
          observer.unobserve(target);

          callback();
        }
      },
      {threshold: 1.0},
    );

    const target = targetRef.current;

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [callback]);

  return targetRef;
}
